// eslint-disable-next-line @cspell/spellchecker
import IQBWCFile from './IQBWCFile';

class QBWCFileLink {
  file: IQBWCFile;

  link: string;

  constructor(file: IQBWCFile, link: string) {
    this.file = file;
    this.link = link;
  }
}

export default QBWCFileLink;
